import { WorkspaceId } from './workspace-id.type';
import { ReachWorkspaceType } from './workspaces-types.type';

export interface ReachWorkspace {
	id: WorkspaceId;

	type: ReachWorkspaceType;

	name: string;
	description?: string;
	createdAt: number;
	updatedAt: number;
	count: number;

	isIntegration?: boolean;
	integrationId?: string;

	emoji?: string;
	thumbnailUrl?: string;

	lastSearch: number;
}
